import React, { useState } from "react";
import { Table } from "reactstrap";
import {
  parsedInvoiceAmount,
  formatIndexLabelCollapse,
} from "../../../utils/utils";
import { commissionDetailsType } from "../../../constants";

const CommissionDetailTable = ({ commission }) => {
  const [isCollapseOpen, setIsCollapseOpen] = useState([]);

  const toggleCollapse = (index, isInner = false, parentIndex = []) => {
    const currentIndex = [...parentIndex, index];
    let newPath = [...isCollapseOpen];
    let isOpen = currentIndex.every((val, idx) => newPath[idx] === val);
    if (isOpen) {
      newPath = newPath.slice(0, currentIndex.length - 1);
    } else {
      newPath = currentIndex;
    }
    setIsCollapseOpen(newPath);
  };

  const renderCollapse = (items, parentIndex = []) => {
    const marginPerLevel = 15;
    return items?.map((item, index) => {
      const currentIndex = [...parentIndex, index];
      const isOpen = currentIndex.every(
        (val, idx) => isCollapseOpen[idx] === val
      );

      const hasInnerItems = item.items && item.items.length > 0;

      const itemIndex =
        parentIndex.length > 0
          ? `${parentIndex.join(".")}.${index + 1}`
          : index + 1;

      return (
        <>
          <tr
            className={`${
              hasInnerItems ? "hover-table-effect" : "no-hover-effect"
            } ${isOpen ? "bg-light" : ""}`}
            onClick={(e) => {
              if (hasInnerItems)
                toggleCollapse(index, hasInnerItems, parentIndex);
            }}
            style={{
              transition: "all 0.3s",
              transform: "all 0.3s",
              cursor: hasInnerItems ? "pointer" : "default",
            }}
          >
            <th
              scope="row"
              className="text-start "
              style={{
                paddingLeft: `${parentIndex.length * marginPerLevel}px`,
              }}
            >
              {formatIndexLabelCollapse(itemIndex)}
            </th>
            <td className="text-start">
              <span className="fw-medium ">{item.description}</span>
              {item.type && (
                <p className="text-muted mb-0">
                  {commissionDetailsType[item.type]}
                </p>
              )}
            </td>
            <td className="text-end">
              ${parsedInvoiceAmount(item.total || item.amount)}
            </td>
            {hasInnerItems ? (
              <td className="text-end" style={{ width: "20px" }}>
                <i
                  className={`fw-semibold fs-5  ri-${
                    isOpen ? "close-line" : "add-line"
                  } icon-toggle`}
                  style={{
                    transform: isOpen ? "rotate(91deg)" : "rotate(0deg)",
                  }}
                ></i>
              </td>
            ) : (
              <td className="text-end" style={{ width: "20px" }}></td>
            )}
          </tr>
          {hasInnerItems && isOpen && renderCollapse(item.items, currentIndex)}
        </>
      );
    });
  };

  const renderCommissionDetailsTable = () => {
    return commission.items?.map((item, index) => {
      const hasInnerItems = item.items && item.items.length > 0;
      const isOpen = isCollapseOpen.includes(index);

      return (
        <div className="table-responsive">
          <Table
            className={`table-borderless text-center  table-nowrap align-middle mb-0 ${
              hasInnerItems ? "" : ""
            }`}
          >
            <thead>
              <tr className="bg" style={{ background: "var(--thead-bg)" }}>
                <th
                  className="text-start"
                  scope="col"
                  style={{ width: "100px" }}
                >
                  #
                </th>
                <th className="text-start" scope="col">
                  Commissions Details
                </th>
                <th scope="col" className="text-end">
                  Amount
                </th>
                <th scope="col" className="text-end"></th>
              </tr>
            </thead>

            <tbody
              className={hasInnerItems ? "cursor-pointer" : "cursor-default"}
              id="products-list"
            >
              <tr
                className={`${
                  hasInnerItems ? "hover-table-effect" : "no-hover-effect"
                } ${isOpen ? "bg-light" : ""}`}
                style={{ cursor: hasInnerItems ? "pointer" : "default" }}
                onClick={
                  hasInnerItems ? () => toggleCollapse(index) : undefined
                }
              >
                <th scope="row" className="text-start">
                  {index + 1}
                </th>
                <td className="text-start">
                  <span className="fw-medium text-start">
                    {item.description}
                  </span>
                  {item.type && (
                    <p className="text-muted mb-0">
                      {commissionDetailsType[item.type]}
                    </p>
                  )}
                </td>
                <td className="text-end">
                  ${parsedInvoiceAmount(item.total || item.amount)}
                </td>
                {hasInnerItems && (
                  <td className="text-end" style={{ width: "20px" }}>
                    <i
                      className={`fw-semibold fs-5 ri-${
                        isOpen ? "close-line" : "add-line"
                      } icon-toggle`}
                      style={{
                        transform: isOpen ? "rotate(91deg)" : "rotate(0deg)",
                      }}
                    ></i>
                  </td>
                )}
              </tr>
              {hasInnerItems && isOpen && renderCollapse(item.items, [index])}
            </tbody>
          </Table>
        </div>
      );
    });
  };

  return <>{renderCommissionDetailsTable()}</>;
};

export default CommissionDetailTable;
